/**
 * This file contains the code for creating or editing the quiz
 */

import React from "react";
import {quiztypeenum} from "../enums/quiztypeenum";


export class LandingPageForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quiz: this.props.quiz,
      user: this.props.user,
      result_page_custom_text: "",
      is_enable_player_result: false,
      privacy_policy_text: [],
    };

    this.isEnablePlayerResult = this.isEnablePlayerResult.bind(this);
    this.handleScoreType = this.handleScoreType.bind(this);
    this.onFieldChanged = this.onFieldChanged.bind(this);
    this.onRadioChanged = this.onRadioChanged.bind(this);
    this.changePersonalityEmailFormCode =
      this.changePersonalityEmailFormCode.bind(this);
    this.changePersonalityLandingFormUrl =
      this.changePersonalityLandingFormUrl.bind(this);
    this.isEnableResultPageCustomText =
      this.isEnableResultPageCustomText.bind(this);
    this.isEnableSocialMedia = this.isEnableSocialMedia.bind(this);
    this.onChangePersonalityWithGrade =
      this.onChangePersonalityWithGrade.bind(this);
    this.onChangeScoreRange = this.onChangeScoreRange.bind(this);
    
  }

  componentWillReceiveProps(nextProps) {
    var quiz = nextProps.quiz;
    var user = nextProps.user;
    if (quiz != null && (quiz.quiztype == quiztypeenum.graded_quiz_with_personality || quiz.quiztype == quiztypeenum.weighted_graded_quiz)) {
      var personalityArr = null;
      if (quiz.quizmetadata != null) {
        personalityArr = JSON.parse(quiz.quizmetadata);
      }
      if (personalityArr == null) {
        personalityArr = [];
        personalityArr.push({ mingrade: 0, maxgrade: 20 });
        personalityArr.push({ mingrade: 21, maxgrade: 40 });
        personalityArr.push({ mingrade: 41, maxgrade: 60 });
        personalityArr.push({ mingrade: 61, maxgrade: 80 });
        personalityArr.push({ mingrade: 81, maxgrade: 100 });
      }
      quiz.personalityArr = personalityArr;
    }

    this.setState({ quiz, user });
  }

  onChangePersonalityWithGrade(e) {
    var quiz = this.state.quiz;
    var personalityArr = quiz.personalityArr;

    var name = e.target.name;
    var index = e.target.getAttribute("data-id");

    personalityArr[index][name] = e.target.value;
    quiz.personalityArr = personalityArr;
    quiz.quizmetadata = JSON.stringify(personalityArr);
    this.setState({ quiz }, () => {
      this.props.updateQuiz(quiz);
    });
  }
  onChangeScoreRange(e) {
    var quiz = this.state.quiz;
    var personalityArr = quiz.personalityArr;

    var name = e.target.name;
    var index = e.target.getAttribute("data-id");

    personalityArr[index][name] = e.target.value;
    quiz.personalityArr = personalityArr;
    quiz.quizmetadata = JSON.stringify(personalityArr);
    this.setState({ quiz }, () => {
      this.props.updateQuiz(quiz);
    });
  }

  onFieldChanged(e) {
    var tempquizobj = this.state.quiz;
    if (tempquizobj == null) {
      tempquizobj = {};
    }
    var name = e.target.name;
    tempquizobj[name] = e.target.value;
    this.setState({ quiz: tempquizobj }, () => {
      this.props.updateQuiz(tempquizobj);
    });
  }

  onRadioChanged(e) {
    var tempquizobj = this.state.quiz;
    if (tempquizobj == null) {
      tempquizobj = {};
    }
    var name = e.target.name;
    tempquizobj[name] = e.target.value;
    this.setState({ quiz: tempquizobj }, () => {
      this.props.updateQuiz(tempquizobj);
    });
  }

  collectUserEmailChange(e) {
    var tempquizobj = this.state.quiz;
    if (tempquizobj == null) {
      tempquizobj = {};
    }
    tempquizobj.collectuseremailflag = e.target.checked ? "1" : "0";
    this.setState({ quiz: tempquizobj }, () => {
      this.props.updateQuiz(tempquizobj);
    });
  }

  isEnablePlayerResult(e) {
    var tempquizobj = this.state.quiz;
    if (tempquizobj == null) {
      tempquizobj = {};
    }
    tempquizobj.is_enable_player_result = e.target.checked ? 1 : 0;
    this.setState({ quiz: tempquizobj }, () => {
      this.props.updateQuiz(tempquizobj);
    });
  }

  handleScoreType(event) {
    var scoretype = event.target.getAttribute("data-value");
    var quiz = this.state.quiz;
    if (quiz == null) {
      quiz = {};
    }
    quiz.scoretype = scoretype;
    this.setState({ quiz }, () => {
      this.props.updateQuiz(quiz);
    });
  }

  changePersonalityEmailFormCode(event) {
    var index = event.target.getAttribute("data-id");
    var quiz = this.state.quiz;
    var personalityArr = quiz != null ? quiz.personalityArr : null;
    if (personalityArr && personalityArr[index]) {
      personalityArr[index].quizemailformcode = event.target.value;
      quiz.personalityArr = personalityArr;
      this.setState({ quiz }, () => {
        this.props.updateQuiz(quiz);
      });
    }
  }
  changePersonalityLandingFormUrl(event) {
    var index = event.target.getAttribute("data-id");
    var quiz = this.state.quiz;
    var personalityArr = quiz != null ? quiz.personalityArr : null;
    if (personalityArr && personalityArr[index]) {
      personalityArr[index].landingformurl = event.target.value;
      quiz.personalityArr = personalityArr;
      this.setState({ quiz }, () => {
        this.props.updateQuiz(quiz);
      });
    }
  }

  privacyPolicy() {}

  privacyPolicyText(e) {
    console.log("e", e.target.value);
    var getQuiz = this.props.quiz;
    getQuiz.privacy_policy_text = e.target.value;
    this.setState({
      quiz: getQuiz,
    });
  }

  isEnableResultPageCustomText(e) {
    var quiz = this.state.quiz;
    quiz.result_page_custom_text = e.target.checked
      ? "<h3>This certificate is proudly presented on completion of the quiz</h3><h2>" +
        this.state.quiz.title +
        "</h2><h2>To</h2>"
      : "";
      this.setState({ quiz }, () => {
        this.props.updateQuiz(quiz);
      });
  }
  isEnableSocialMedia(e) {
    var quiz = this.state.quiz;
    quiz.is_enable_social_media = e.target.checked ? 1 : 0;
    this.setState({ quiz }, () => {
      this.props.updateQuiz(quiz);
    });
  }

  renderPersonalities() {
    var self = this;
    var personalityArr = null;
    if (this.state.quiz != null && this.state.quiz.personalityArr) {
      personalityArr = this.state.quiz.personalityArr;
    }
    if (personalityArr != null && personalityArr.length > 0) {
      return personalityArr.map(function (personality, counter) {
        return (
          <option
            key={counter}
            value={personality.title}
            selected={
              self.state.personalityArr != null &&
              self.state.personalityArr[counter] != null &&
              self.state.quiz.personalityArr[counter].title == personality.title
                ? true
                : false
            }
          >
            {personality.title}
          </option>
        );
      }, this);
    } else {
      return null;
    }
  }

  //Email form setting for personality quiz
  renderPersonalityEmailFormSettings() {
    var personalities =
      this.state.quiz != null ? this.state.quiz.personalityArr : null;
    var content = null;
    if (personalities != null) {
      var temp = personalities.map((element, index) => {
        return (
          <div
            className="col-md-12 ans-wrapper-modify"
            key={index}
            style={{ paddingLeft: 0 }}
          >
            <div id={"divpersonality" + index} className="">
              <div
                style={{ color: "red", fontSize: 12 }}
                id={"anserror" + index + 1}
              ></div>
              <div className="">
                <div
                  className="col-md-3 col-sm-3 col-xs-12"
                  style={{ height: 50, marginTop: 0, paddingLeft: 0 }}
                >
                  <label>{element.title}</label>
                </div>
                <div className="col-md-9 col-sm-9 col-xs-12 ans-option-list">
                  <textarea
                    className="Sign-In-TextBox"
                    id={"ans" + index + 1}
                    onChange={this.changePersonalityEmailFormCode}
                    data-id={index}
                    value={element == null ? "" : element.quizemailformcode}
                    placeholder="Enter HTML code for email form"
                  />
                </div>
              </div>
            </div>
          </div>
        );
      });
      content = (
        <div>
          <h5 className="Sign-In-Label">
            Please enter html code for email form for personalities{" "}
          </h5>
          <br />
          {temp}
        </div>
      );
    }

    return content;
  }

  //Email form setting for graded quiz
  renderGradedEmailFormSetting() {
    return (
      <>
        <div className="Sign-In-Label">
          Enter HTML code for lead generation form
        </div>
        <textarea
          className="Sign-In-TextBox"
          onChange={this.onFieldChanged}
          name="quizemailformcode"
          value={
            this.state.quiz != null ? this.state.quiz.quizemailformcode : ""
          }
          style={{ marginTop: 5, width: 100 + "%", height: 150 }}
        />
        <span className="help-block error-block basic-block">Required</span>
      </>
    );
  }

  
  //Email form setting for multiple grades
  renderMultipleGradeEmailFormSetting() {
    var self = this;
    var personalityArr = null;
    var customlandingflag = self.state.quiz && self.state.quiz.emailformtype == "custom"? true: false;
      if (this.state.quiz != null && this.state.quiz.personalityArr) {
        personalityArr = this.state.quiz.personalityArr;
      }
      if (personalityArr != null && personalityArr.length > 0) {
        return personalityArr.map(function (personality, index) {
          return (
            <div className="row" style={{ marginBottom: 8 }}>
              <div className="col-md-3">
                {personality.mingrade} - {personality.maxgrade} %
              </div>
              {customlandingflag ? (
                <div className="col-md-9">
                  <textarea
                    className="Sign-In-TextBox"
                    type="text"
                    placeholder="Enter HTML code for lead generation form"
                    name="quizemailformcode"
                    data-id={index}
                    onChange={self.onChangePersonalityWithGrade}
                    value={personality.emailformcode || personality.quizemailformcode}
                  ></textarea>
                </div>
              ) : null}
            </div>
          );
        }, this);
      } else {
        return null;
      }
  
    //else{
    // return (
    //   <>
    //     <div className="Sign-In-Label">
    //       Enter HTML code for lead generation form
    //     </div>
    //     <textarea
    //       className="Sign-In-TextBox"
    //       onChange={this.onFieldChanged}
    //       name="quizemailformcode"
    //       value={
    //         this.state.quiz != null ? this.state.quiz.quizemailformcode : ""
    //       }
    //       style={{ marginTop: 5, width: 100 + "%", height: 150 }}
    //     />
    //     <span className="help-block error-block basic-block">Required</span>
    //   </>
    // );
  }

  //Landing form setting for personality quiz
  renderPersonalityLandingFormSettings() {
    var personalities =
      this.state.quiz != null ? this.state.quiz.personalityArr : null;
    var content = null;
    if (personalities != null) {
      var temp = personalities.map((element, index) => {
        return (
          <div
            className="col-md-12 ans-wrapper-modify"
            key={index}
            style={{ paddingLeft: 0 }}
          >
            <div id={"divpersonality" + index} className="">
              <div
                style={{ color: "red", fontSize: 12 }}
                id={"anserror" + index + 1}
              ></div>
              <div className="">
                <div
                  className="col-md-2 col-sm-2 col-xs-12"
                  style={{ height: 50, marginTop: 0 }}
                >
                  <label>{element.title}</label>
                </div>
                <div className="col-md-10 col-sm-10 col-xs-10 ans-option-list">
                  <input
                    type="url"
                    className="Sign-In-TextBox"
                    id={"ans" + index + 1}
                    onChange={this.changePersonalityLandingFormUrl}
                    data-id={index}
                    value={element == null ? "" : element.landingformurl}
                    placeholder="Enter url for landing page"
                  />
                </div>
              </div>
            </div>
          </div>
        );
      });
      content = (
        <div>
          <h5 className="Sign-In-Label">
            Please enter url for landing page for personalities{" "}
          </h5>
          <br />
          {temp}
        </div>
      );
    }

    return content;
  }

  //Landing form setting for graded quiz
  renderGradedLandingFormSetting() {
    return (
      <>
        <div className="Sign-In-Label">Enter url for custom landing page</div>
        <input
          className="Sign-In-TextBox"
          type="url"
          onChange={this.onFieldChanged}
          name="landingformurl"
          value={this.state.quiz != null ? this.state.quiz.landingformurl : ""}
          style={{ marginTop: 5, width: 100 + "%" }}
        />
        <span className="help-block error-block basic-block">Required</span>
      </>
    );
  }

  //Landing form setting for graded quiz with grades
  renderPersonalitiesWithGrades() {
    var self = this;
    var personalityArr = null;
    var customlandingflag =
      self.state.quiz && self.state.quiz.landingformtype == "custom"
        ? true
        : false;
    if (this.state.quiz != null && this.state.quiz.personalityArr) {
      personalityArr = this.state.quiz.personalityArr;
    }
    if (personalityArr != null && personalityArr.length > 0) {
      return personalityArr.map(function (personality, index) {
        return (
          <div className="row" style={{ marginBottom: 8 }}>
            <div className="col-md-3">
              {personality.mingrade} - {personality.maxgrade} %
            </div>
            <div className={customlandingflag ? "hide" : "col-md-4"}>
              <textarea
                className="Sign-In-TextBox"
                type="text"
                placeholder="Enter personality title"
                name="title"
                data-id={index}
                onChange={this.onChangePersonalityWithGrade}
                value={personality.title}
              ></textarea>
            </div>
            <div className={customlandingflag ? "hide" : "col-md-5"}>
              <textarea
                className="Sign-In-TextBox"
                type="text"
                placeholder="Enter personality description"
                name="description"
                data-id={index}
                onChange={this.onChangePersonalityWithGrade}
                value={personality.description}
              ></textarea>
            </div>
            {customlandingflag ? (
              <div className="col-md-9">
                <textarea
                  className="Sign-In-TextBox"
                  type="text"
                  placeholder="Enter url for landing page for score-range"
                  name="landingformurl"
                  data-id={index}
                  onChange={this.onChangePersonalityWithGrade}
                  value={personality.landingformurl}
                ></textarea>
              </div>
            ) : null}
          </div>
        );
      }, this);
    } else {
      return null;
    }
  }

  renderOutcomesWithScoreRange() {
    var self = this;
    var personalityArr = null;
    var customlandingflag = self.state.quiz && self.state.quiz.landingformtype == "custom"? true: false;

    if (this.state.quiz != null && this.state.quiz.personalityArr) {
      personalityArr = this.state.quiz.personalityArr;
    }
    if (personalityArr != null && personalityArr.length > 0) {
      return personalityArr.map(function (personality, index) {
        return (
          <div className="row" style={{ marginBottom: 8 }}>
            <div className={`${customlandingflag?'col-md-2':'col-md-2'}`}>
              <input style={{padding:0, textAlign:"center"}}
                type="text"
                data-id={index}
                className="form-control custome_input"
                value={personality.mingrade}
                name="mingrade"
                onChange={this.onChangeScoreRange}
              />
            </div>
            <div className={`${customlandingflag?'col-md-2':'col-md-2'}`}>
              <input
                type="text"
                data-id={index}
                className="form-control custome_input"
                value={personality.maxgrade}
                name="maxgrade"
                onChange={this.onChangeScoreRange}
              />
            </div>
            <div className={`${customlandingflag?'hide':'col-md-4'}`}>
              <textarea
                className="Sign-In-TextBox"
                type="text"
                placeholder="Enter outcome title"
                name="title"
                data-id={index}
                onChange={this.onChangePersonalityWithGrade}
                value={personality.title}
              ></textarea>
            </div>
            <div className={`${customlandingflag?'hide':'col-md-4'}`}>
              <textarea
                className="Sign-In-TextBox"
                type="text"
                placeholder="Enter outcome description"
                name="description"
                data-id={index}
                onChange={this.onChangePersonalityWithGrade}
                value={personality.description}
              ></textarea>
            </div>
            {customlandingflag?<div className={`${customlandingflag?'col-md-8':'col-md-4'}`}>
                <textarea
                  className="Sign-In-TextBox"
                  type="text"
                  placeholder="Enter outcome url"
                  name="url"
                  data-id={index}
                  onChange={this.onChangePersonalityWithGrade}
                  value={personality.url}
                ></textarea>
              </div>:null}
           
          </div>
        );
      }, this);
    } else {
      return null;
    }
  }

  render() {
    var customlandingflag =
      this.state.quiz && this.state.quiz.landingformtype == "custom"
        ? true
        : false;
    return (
      
        <div className="col-md-12">
            <div className="row">
              <div className="col-md-12">
                <div className="Sign-In-Label">Select landing page</div>
                <input
                  type="radio"
                  onChange={this.onRadioChanged}
                  name="landingformtype"
                  value="standard"
                  checked={
                    this.state.quiz == null ||
                    this.state.quiz.landingformtype == null ||
                    this.state.quiz.landingformtype == "standard"
                      ? true
                      : false
                  }
                />
                <span style={{ marginLeft: 5 }}>Standard</span>
                <input
                  type="radio"
                  onChange={this.onRadioChanged}
                  name="landingformtype"
                  value="custom"
                  style={{ marginLeft: 20 }}
                  checked={
                    this.state.quiz != null &&
                    this.state.quiz.landingformtype != null &&
                    this.state.quiz.landingformtype == "custom"
                      ? true
                      : false
                  }
                />
                <span style={{ marginLeft: 5 }}>Custom</span>
                <p className="upgrade_error">
                  {this.state.messageUpgradechecbox}
                </p>
              </div>
            </div>

            <div
              id="lead-generate-form"
              className={`${
                this.state.quiz != null &&
                this.state.quiz.landingformtype == "custom"
                  ? ""
                  : "hide"
              }`}
            >
              {this.state.quiz != null &&
                ((this.state.quiz.quiztype == quiztypeenum.personality_quiz ||
                this.state.quiz.quiztype == quiztypeenum.multiple_personality_quiz || this.state.quiz.quiztype == quiztypeenum.category_quiz_multiple_personality || this.state.quiz.quiztype == quiztypeenum.category_graded_quiz_with_personality
                  ? this.renderPersonalityLandingFormSettings()
                  : null) ||
                  (this.state.quiz.quiztype == quiztypeenum.graded_quiz_with_personality ||
                  this.state.quiz.quiztype == quiztypeenum.weighted_graded_quiz ? (
                    <div
                      className={`col-md-12 ${
                        this.state.quiz != null &&
                        (this.state.quiz.quiztype == quiztypeenum.graded_quiz_with_personality ||
                          this.state.quiz.quiztype == quiztypeenum.weighted_graded_quiz)
                          ? ""
                          : "hide"
                      }`}
                    >
                      <div className="form-group has-feedback">
                        <label className="Sign-In-Label" htmlFor="productName">
                          {this.state.quiz.quiztype == quiztypeenum.graded_quiz_with_personality
                            ? (customlandingflag?"Assign custom urls to Score Range":"Assign Personalities to Score Range")
                            : (customlandingflag?"Assign custom urls to Score Range":"Assign Outcomes to Score Range")}
                        </label>
                        <div className="Sign-In-Label">
                          <div className="row" style={{ marginBottom: 8 }}>
                            <div className={`${customlandingflag?"col-md-4":"col-md-3"}`} style={{ height: 20 }}>
                              Score Range
                            </div>
                            <div
                              className={
                                customlandingflag ? "hide" : "col-md-4"
                              }
                              style={{ height: 20 }}
                            >
                              Title
                            </div>
                            <div
                              className={
                                customlandingflag ? "hide" : "col-md-5"
                              }
                              style={{ height: 20 }}
                            >
                              Description
                            </div>
                            <div className={
                                customlandingflag ? "col-md-8":"hide"
                              } style={{ height: 20 }}>
                              Url
                            </div>
                            
                          </div>
                          {this.state.quiz.quiztype == quiztypeenum.graded_quiz_with_personality
                          ? this.renderPersonalitiesWithGrades()
                          : (customlandingflag?this.renderOutcomesWithScoreRange():null)}
                        </div>
                      </div>
                    </div>
                  ) : null) || 
                  (this.state.quiz.quiztype == quiztypeenum.graded_quiz ? (
                    <div
                      className={`col-md-12 ${
                        this.state.quiz != null &&
                        this.state.quiz.quiztype == quiztypeenum.graded_quiz ? "": "hide"}`}
                    >
                      <div className="form-group has-feedback">
                        {this.renderGradedLandingFormSetting()}
                      </div>
                    </div>
                  ) : null)
              )
            }
            </div>
            {this.state.quiz == null ||
            this.state.quiz.landingformtype == null ||
            this.state.quiz.landingformtype == "standard" ? (
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <div
                      className="form-group has-feedback"
                      id={
                        this.state.quiz != null &&
                        this.state.quiz.quiztype == quiztypeenum.graded_quiz
                          ? ""
                          : "r-p"
                      }
                    >
                      <div className="Sign-In-Label" htmlFor="productName">
                        Show score in {" "}
                      </div>
                      <div className="Sign-In-Label">
                        <div className="row">
                          <div className="col-md-6" style={{ height: 20 }}>
                            <input
                              type="radio"
                              name="inlineRadioOptions1"
                              value="Marks"
                              checked={
                                this.state.quiz == null ||
                                this.state.quiz.scoretype == "Marks"
                              }
                              onChange={this.handleScoreType}
                              data-value="Marks"
                            />
                            <span>Marks</span>
                          </div>
                          <div className="col-md-6" style={{ height: 20 }}>
                            <input
                              type="radio"
                              name="inlineRadioOptions2"
                              value="Percentage"
                              checked={
                                this.state.quiz == null ||
                                this.state.quiz.scoretype == "Percentage"
                              }
                              onChange={this.handleScoreType}
                              data-value="Percentage"
                            />
                            <span>Percentage</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-md-12 ${
                      this.state.quiz != null &&
                      (this.state.quiz.quiztype == quiztypeenum.graded_quiz_with_personality ||
                        this.state.quiz.quiztype == quiztypeenum.weighted_graded_quiz)
                        ? ""
                        : "hide"
                    }`}
                  >
                    <div className="form-group has-feedback">
                      <label className="Sign-In-Label" htmlFor="productName">
                        {this.state.quiz.quiztype == quiztypeenum.graded_quiz_with_personality
                          ? "Assign Personalities to Score Range"
                          : "Assign Outcomes to Score Range"}
                      </label>
                      <div className="Sign-In-Label">
                        <div className="row" style={{ marginBottom: 8 }}>
                          <div className="col-md-3" style={{ height: 20 }}>
                            Score Range
                          </div>
                          <div
                            className={
                              customlandingflag ? "col-md-3" : "col-md-4"
                            }
                            style={{ height: 20 }}
                          >
                            Title
                          </div>
                          <div
                            className={
                              customlandingflag ? "col-md-3" : "col-md-5"
                            }
                            style={{ height: 20 }}
                          >
                            Description
                          </div>
                          {customlandingflag ? (
                            <div className="col-md-3" style={{ height: 20 }}>
                              Url
                            </div>
                          ) : null}
                        </div>
                        {this.state.quiz.quiztype == quiztypeenum.graded_quiz_with_personality
                          ? this.renderPersonalitiesWithGrades()
                          : this.renderOutcomesWithScoreRange()}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div
                      className="form-group has-feedback"
                      ng-class="{'has-error': vm.addressForm.address.$invalid &amp;&amp; (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"
                    >
                      <div className="Sign-In-Label">Offer Message</div>
                      <input
                        // name="offermsg"
                        onChange={this.onFieldChanged}
                        name="quizoffermsg"
                        className="Sign-In-TextBox"
                        required=""
                        type="text"
                        placeholder="Schedule a free visit"
                        maxLength="50"
                        value={
                          this.state.quiz != null
                            ? this.state.quiz.quizoffermsg
                            : ""
                        }
                      />
                      <div className="counter-wrapper">
                        <span>
                          {this.state.quiz.quizoffermsg != null
                            ? this.state.quiz.quizoffermsg.length
                            : "0"}
                          /50
                        </span>
                      </div>
                      <div className="Sign-In-Label">Offer Button Text</div>
                      <input
                        onChange={this.onFieldChanged}
                        className="Sign-In-TextBox"
                        required=""
                        name="quizofferbtntxt"
                        type="text"
                        placeholder="Schedule Now"
                        maxLength="20"
                        value={
                          this.state.quiz != null
                            ? this.state.quiz.quizofferbtntxt
                            : ""
                        }
                      />
                      <div className="counter-wrapper">
                        <span>
                          {this.state.quiz.quizofferbtntxt != null
                            ? this.state.quiz.quizofferbtntxt.length
                            : "0"}
                          /20
                        </span>
                      </div>
                      <div className="Sign-In-Label">Offer Button Link</div>
                      <input
                        // name="offerbtnlinkmsg"
                        onChange={this.onFieldChanged}
                        className="Sign-In-TextBox"
                        required=""
                        name="quizofferbtnlink"
                        type="text"
                        placeholder="www.quizzes4leads.com"
                        maxLength="50"
                        value={
                          this.state.quiz != null
                            ? this.state.quiz.quizofferbtnlink
                            : ""
                        }
                      />
                      <div className="counter-wrapper">
                        <span>
                          {this.state.quiz.quizofferbtnlink != null
                            ? this.state.quiz.quizofferbtnlink.length
                            : "0"}
                          /50
                        </span>
                      </div>
                      
                      {/* <div className="Sign-In-Label">Book A Call Text</div>
                      <input
                        name="book_a_call_button_text"
                        onChange={this.onFieldChanged}
                        className="Sign-In-TextBox"
                        type="text"
                        placeholder="Book A Call"
                        maxLength="20"
                        value={
                          this.state.quiz != null
                            ? this.state.quiz.book_a_call_button_text
                            : ""
                        }
                      />
                      <div className="counter-wrapper">
                        <span>
                          {this.state.quiz.book_a_call_button_text != null
                            ? this.state.quiz.book_a_call_button_text.length
                            : "0"}
                          /20
                        </span>
                      </div> */}
                      <div className="Sign-In-Label">Retake This Quiz Text</div>
                      <input
                        name="retake_this_quiz_text"
                        onChange={this.onFieldChanged}
                        className="Sign-In-TextBox"
                        type="text"
                        placeholder="Retake This Quiz"
                        maxLength="50"
                        value={
                          this.state.quiz != null
                            ? this.state.quiz.retake_this_quiz_text
                            : ""
                        }
                      />
                      <div className="counter-wrapper">
                        <span>
                          {this.state.quiz.retake_this_quiz_text != null
                            ? this.state.quiz.retake_this_quiz_text.length
                            : "0"}
                          /50
                        </span>
                      </div>
                      {/* {this.state.quiz.quiztype!=quiztypeenum.personality_quiz && this.state.quiz.quiztype!=quiztypeenum.graded_quiz_with_personality && this.state.quiz.quiztype!=quiztypeenum.multiple_personality_quiz && this.state.quiz.quiztype!=quiztypeenum.category_quiz_multiple_personality && this.state.quiz.quiztype!=quiztypeenum.category_graded_quiz_with_personality ?<>
                      <div className="Sign-In-Label">
                        This Certificate Is Proudly Text...
                      </div>
                      <input
                        name="this_is_certificate_is_text"
                        onChange={this.onFieldChanged}
                        className="Sign-In-TextBox"
                        type="text"
                        maxLength="50"
                        placeholder="This Certificate Is Proudly..."
                        value={
                          this.state.quiz != null
                            ? this.state.quiz.this_is_certificate_is_text
                            : ""
                        }
                      />
                      
                      <div className="counter-wrapper">
                        <span>
                          {this.state.quiz.this_is_certificate_is_text != null
                            ? this.state.quiz.this_is_certificate_is_text.length
                            : "0"}
                          /50
                        </span>
                      </div>
                      </> :null} */}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            
           
        {this.state.quiz && this.state.quiz.landingformtype=='standard'? 
        <div className="row">
          <div className="col-md-12">
            <div className="Sign-In-Label">
              <input
                type="checkbox"
                onChange={this.isEnableSocialMedia}
                name="is_enable_social_media"
                checked={
                  this.state.quiz == null ||
                  this.state.quiz.is_enable_social_media
                    ? true
                    : false
                }
              />{" "}
              Enable social sharing ?
            </div>
          </div>
        </div> : null }
      </div>
    );
  }
}




